import { Playground } from '../../../components/playground/Playground';
import { Description } from '../../../components/Description';
import { Title } from '../../../components/Title';

import { icons } from '../../../utils/icons';
import { getNames } from '../../../utils/mapUtils';

const humanIcons = [...getNames(icons.humans)] as string[];

export const RioglyphDisabled = () => (
    <div className='uikit-icons'>
        <Description headline='Disabled icons' headlineType='h3' anchor='disabledIcons' />
        <Playground example={rioglyphDisabledIconsExample} />
    </div>
);

const rioglyphDisabledIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Default</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='rioglyph rioglyph-wifi rioglyph-disabled text-size-150pct' />
                <span className='rioglyph rioglyph-lock rioglyph-disabled text-size-150pct' />
                <span className='rioglyph rioglyph-globe rioglyph-disabled text-size-150pct' />
                <span className='rioglyph rioglyph-api rioglyph-disabled text-size-150pct' />
                <span className='rioglyph rioglyph-chat rioglyph-disabled text-size-150pct' />
            </div>
        </div>
        <div>
            <Title>With red line</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='rioglyph rioglyph-wifi rioglyph-disabled rioglyph-disabled-danger text-size-150pct' />
                <span className='rioglyph rioglyph-lock rioglyph-disabled rioglyph-disabled-danger text-size-150pct' />
                <span className='rioglyph rioglyph-globe rioglyph-disabled rioglyph-disabled-danger text-size-150pct' />
                <span className='rioglyph rioglyph-api rioglyph-disabled rioglyph-disabled-danger text-size-150pct' />
                <span className='rioglyph rioglyph-chat rioglyph-disabled rioglyph-disabled-danger text-size-150pct' />
            </div>
        </div>
        <div>
            <Title>Inverse</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='rioglyph rioglyph-wifi rioglyph-disabled rioglyph-disabled-inverse text-size-150pct' />
                <span className='rioglyph rioglyph-lock rioglyph-disabled rioglyph-disabled-inverse text-size-150pct' />
                <span className='rioglyph rioglyph-key rioglyph-disabled rioglyph-disabled-inverse text-size-150pct' />
                <span className='rioglyph rioglyph-api rioglyph-disabled rioglyph-disabled-inverse text-size-150pct' />
                <span className='rioglyph rioglyph rioglyph-wrench rioglyph-disabled rioglyph-disabled-inverse text-size-150pct' />
            </div>
        </div>
    </div>
);
